import DependedFieldsService from "../depended-fields/DependedFieldsService";
import i18n from "../../../shared/i18n";
import _ from 'lodash';
import DependedFieldModel from "../depended-fields/DependedField.model";
import DependedFieldSearchModel from "@/modules/setup/depended-fields/DependedFieldSearch.model";


let getDefaultTableData = () => {
  return {
    loading: false,
    rows: [],
    searchModel: new DependedFieldSearchModel(),
    pagination: {
      limit: 25,
      page: 1,
      total: 0,
    },
    ordering: '-created_at',
  }
};

const dependedField = {
  namespaced: true,
  state: {
    modal: {
      show: false,
      model: new DependedFieldModel()
    },
    mainFields: {
      loading: false,
      rows: []
    },
    dependedFields: getDefaultTableData(),
    selectedMainField: null,
  },
  getters: {
    tableFields: (state) => {
      const fields = [
        {
          key: 'key',
          label: i18n.t('Key'),
          sortable: false,
        },
        {
          key: state.selectedMainField.key,
          label: state.selectedMainField.label,
          sortable: false
        }
      ];
      const fieldsToOrder = [];
      state.selectedMainField.depended_fields.forEach(key => fieldsToOrder.push({
        key: key,
        label: state.selectedMainField.config[key].label,
        position: state.selectedMainField.config[key].position,
        sortable: false
      }))
      return [...fields, ..._.orderBy(fieldsToOrder, ['position'], ['asc'])];
    },
  },
  actions: {
    showModal({commit}, dependedField = null) {
      commit('showModal', dependedField);
    },
    hideModal({commit}) {
      commit('hideModal');
    },
    async getMainFields({commit}) {
      commit('changeMainFieldsLoading');
      const res = await DependedFieldsService.getMainFields();
      const {success, body} = res;
      if (success) {
        commit('setMainFields', body);
      }
      commit('changeMainFieldsLoading');
      return res;
    },
    async selectMainField({commit, dispatch, state}, mainField) {
      if (state.selectedMainField && state.selectedMainField.key === mainField.key) {
        return;
      }
      if (!mainField.config) {
        const {success: mainFieldSuccess, body:mainFieldData} = await DependedFieldsService.getDependedFieldsConfig({key: mainField.key, depended_fields: mainField.depended_fields});
        if (mainFieldSuccess) {
          mainField = {...mainField, config: mainFieldData.data};
          commit('updateMainField', mainField);
        }
      }
      commit('selectMainField', mainField);
      dispatch('loadDependedFields');
    },
    async loadDependedFields({commit, dispatch}, payload) {
      const params = await dispatch('getTableParams', payload);
      commit("updateTableLoading", true);
      const {success, body} = await DependedFieldsService.getDependedFieldsData(params);
      commit("updateTableLoading", false);
      if (success) {
        commit("updateDependedFieldsTable", {
          rows: body.results,
          pagination: {limit: params.limit, page: params.page, total: body.count},
          ordering: params.ordering,
          search: params.search
        });
      }
    },
    async getTableParams({state}, payload = null) {
      let data = {
        limit: state.dependedFields.pagination.limit,
        page: state.dependedFields.pagination.page,
        ordering: state.dependedFields.ordering
      };
      if (payload) {
        data = {
          ...data,
          ...payload
        };
      }

      if (state.dependedFields.searchModel) {
        const searchModelData = state.dependedFields.searchModel.toJSON();
        data = {
          ...data,
          ...searchModelData
        }
      }

      data.key = state.selectedMainField.key
      return data;
    },
    async saveDependedField({dispatch}, data) {
      let response = null;
      if (data.uuid) {
        response = await DependedFieldsService.updateDependedField(data.uuid, data);
      } else {
        response = await DependedFieldsService.createDependedField(data);
      }
      if (response.success) {
          dispatch('loadDependedFields')
      }
      return response;
    },
    async removeDependedField({dispatch}, dependedField) {
      let response = await DependedFieldsService.removeDependedField(dependedField.uuid);
      if (response.success) {
        dispatch('loadDependedFields')
      }
      return response;
    },
    resetTableDataPaginationPage({state}) {
      state.dependedFields.pagination.page = 1;
    },
    async resetTable({state, dispatch}) {
      let defaultTableData = getDefaultTableData();
      defaultTableData.pagination.limit = state.dependedFields.pagination.limit;
      state.dependedFields = defaultTableData;
      dispatch('loadDependedFields');
    },
    updateSearchModel({state}, searchModel) {
      state.dependedFields.searchModel = new DependedFieldSearchModel({
        ...state.dependedFields.searchModel,
        ...searchModel
      })
    },
  },
  mutations: {
    showModal: (state, dependedField) => {
      state.modal.model = new DependedFieldModel();
      if (dependedField) {
        state.modal.model.uuid = dependedField.uuid;
        state.modal.model.key = dependedField.key;
        state.modal.model.dynamic_fields = dependedField.data;
      }
      const dynamicFields = {...state.selectedMainField.config};
      dynamicFields[state.selectedMainField.key].position = -1;
      dynamicFields[state.selectedMainField.key].field_class_name = 'CharField';
      dynamicFields[state.selectedMainField.key].type = 'text';
      dynamicFields[state.selectedMainField.key].rules.required = true;
      state.modal.model.initDynamicFields(state.modal.model, dynamicFields);
      state.modal.show = true;
    },
    hideModal: state => state.modal.show = false,
    setMainFields: (state, mainFields) => {
      state.mainFields.rows = mainFields.data;
    },
    changeMainFieldsLoading: state => state.mainFields.loading = !state.mainFields.loading,
    selectMainField: (state, mainField) => state.selectedMainField = mainField,
    updateMainField: (state, mainField) => {
      for (let i = 0; i < state.mainFields.rows.length; i++) {
        if (state.mainFields.rows[i].key === mainField.key) {
          state.mainFields.rows[i] = {...state.mainFields.rows[i], config: mainField.config};
          break;
        }
      }
      state.dependedFields = getDefaultTableData();
    },
    updateTableLoading: (state, loading) => state.dependedFields.loading = loading,
    updateDependedFieldsTable: (state, payload) => {
      state.dependedFields.pagination = {...state.dependedFields.pagination, ...payload.pagination};
      state.dependedFields.rows = payload.rows;
    }
  }
};

export default dependedField;
